<template>
    <div class="contract">

        <div class="mess_right">
            <div class="mess_title">
                <div class="text">合同签署</div>
                <div class="search">
                    <el-input v-model="search" placeholder="请输入合同标题" clearable @change="handlSearch"></el-input>
                    <div class="btn" @click="handlSearch">搜索</div>
                </div>
                <div class="dateText">更新时间筛选：</div>
                <div class="startDate">
                    <!-- <el-date-picker v-model="date" @change="handlDateChange" value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker> -->

                    <el-date-picker v-model="date" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="handlDateChange">
                    </el-date-picker>
                </div>
            </div>
            <div class="mess_table">
                <el-table :data="tableData" style="width: 100%" id="table">
                    <el-table-column label="合同标题" width="250">
                        <template slot-scope="scope">
                            <div class="">
                                <input :value="(scope.row.title).trim()" style="text-align: center"
                                       @change="handlChange($event,scope.row)" class="titleClass"></input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="signState" label="合同状态" width="250">
                        <template slot="header" slot-scope="scope">
                            <div class="tableHeader">
                                <div>
                                    合同状态
                                </div>
                                <div>
                                    <el-select v-model="value" placeholder="全部" @change="handlSelect" clearable>
                                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                                                   :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column prop="et" label="更新时间" width="220">
                    </el-table-column>
                    <el-table-column label="签署操作">
                        <template slot-scope="scope">
                            <div class="tableScope">
                                <div class="tableBtnS" @click="userDialogVisible = true; contractId = scope.row.id"
                                     v-show="scope.row.signState == '我签署完成' && scope.row.memberId == $global.webData.id">
                                    立即抄送
                                </div>
                                <div class="tableBtnS" v-show="scope.row.signState == '需要我签名'"
                                     @click="handlCheckSign(scope.row)">立即签名
                                </div>
                                <div class="tableBtnS" @click="handlOver(scope.row)"
                                     v-show="scope.row.signState == '起草中'">结束起草
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="合同操作">
                        <template slot-scope="scope">
                            <div class="tableScope">
                                <div class="tableBtn" @click="handlCheckLook(scope.row)">详情</div>
                                <div class="tableBtn" @click="handlCheckDown(scope.row)">下载</div>
                                <div class="tableBtn" @click="handlDeleted(scope.row)">删除</div>
                            </div>
                        </template>
                    </el-table-column>


                </el-table>
                <el-dialog title="立即抄送" :visible.sync="userDialogVisible" width="30%" center id="userDialog"
                           @close="handlDialogClose">
                    <div style="width: 100%;text-align: center;margin-bottom: 10px;">
                        注意：只能抄送给本平台其他用户
                    </div>
                    <div class="dialogEmPh">
                        <el-input placeholder="请输入抄送人手机号" v-model="send.EmaPho"></el-input>
                    </div>
                    <div class="dialogUser">
                        <el-input placeholder="请输入抄送人姓名" v-model="send.name"></el-input>
                    </div>
                    <div class="dialog_btn" @click="handlCheckSend">确认</div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import htmlDocx from 'html-docx-js/dist/html-docx';
    import saveAs from 'file-saver';

    export default {
        data() {
            return {
                search: '',
                userDialogVisible: false,
                date: [],
                send: {
                    EmaPho: '',
                    name: ''
                },
                options: [{
                    value: '0',
                    label: '起草中'
                },
                    {
                        value: '1 ',
                        label: '待他人签名'
                    },
                    {
                        value: '2',
                        label: '需要我签名'
                    },
                    {
                        value: '3',
                        label: '我签署完成'
                    },
                    {
                        value: '4',
                        label: '已取消'
                    },
                    {
                        value: '5',
                        label: '他人签署完成'
                    },
                ],
                value: '',
                tableData: [],
                timeState: 0,
                contractId: 0
            }
        },
        mounted() {
            let _this = this;
            let param = new FormData();
            param.append('token', _this.$global.token);
            _this.getData(param)
        },
        methods: {
            handlDialogClose() {

                this.send = {
                    EmaPho: '',
                    name: ''
                }
            },
            handlCheckSign(row) {

                //alert(row.contactPath);
                this.$router.push({
                    name: 'signContract',
                    params: {
                        pdf: row.contactPath,
                        id: row.id
                    }
                })
            },
            handlInput(e) {
                console.log(e.currentTarget.value)
            },
            handlChange(e, row) {
                let _this = this;
                const title = e.currentTarget.value;
                _this.$confirm('此操作将修改合同标题, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    if (res === 'confirm') {
                        if (!title.trim()) {
                            row.title = row.title + " ";
                            return _this.$message.error('合同标题不能为空')
                        }
                        let params = new FormData();
                        params.append('contactId', row.id);
                        params.append('title', title);
                        _this.api.updateTitle(params).then(res => {
                            console.log(res);
                            _this.$message.success('修改成功');
                            let formData = new FormData();
                            formData.append('token', _this.$global.token);
                            _this.getData(formData)
                        })
                    }
                }).catch((e) => {
                    console.log(3)
                    if (e === 'cancel') {
                        let oldTitle = row.title;
                        console.log('已取消', oldTitle)
                        row.title = (oldTitle + " ");
                    }
                });

            },
            handlCheckDown(row) {
                let _this = this;
                console.log('准备下载')
                if (row.signState == '我签署完成' || row.signState == '他人签署完成') {
                    var path = _this.$global.Local + row.contactPath
                    console.log(path)
                    var a = document.createElement("a"); //创建一个<a></a>标签
                    a.href = path; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
                    a.download = path.substr(path.lastIndexOf("/")+1); //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
                    a.style.display = "none"; // 障眼法藏起来a标签
                    a.target = '_blank';
                    document.body.appendChild(a); // 将a标签追加到文档对象中
                    a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
                    a.remove(); // 一次性的，用完就删除a标签
                    //window.location.href = _this.$global.Local + row.contactPath
                } else {
                    var html = row.content;
                    const converted = htmlDocx.asBlob(html);
                    saveAs(converted, row.title + '.docx');
                }
            },
            handlSelect() {
                console.log(this.value)
                let params = new FormData();
                params.append('token', this.$global.token);
                params.append('signState', this.value);
                params.append('title', this.search);
                this.getData(params);
            },
            handlOver(row) {

                let _this = this;

                // 结束起草PDF类型的合同信息
                if( row.type ==2 ){

                    alert("结束起草")

                    // 封装请求参数
                    let param = new FormData();
                    param.append('id', row.id);
                    param.append('token', _this.$global.token);
                    // 【API请求】----结束起草 [pdf类型] 的合同
                    _this.api.updateContactByPdf(param).then(res => {
                        console.log(res);
                        _this.$message.success('已结束起草状态');
                        let formData = new FormData();
                        formData.append('token', _this.$global.token);
                        _this.getData(formData)
                    })

                }else{

                    // 封装请求参数
                    let param = new FormData();
                    param.append('id', row.id);
                    param.append('token', _this.$global.token);
                    // 【API请求】----结束起草 [ 富文本类型 ]的合同
                    _this.api.updateContact(param).then(res => {
                        console.log(res);
                        _this.$message.success('已结束起草状态');
                        let formData = new FormData();
                        formData.append('token', _this.$global.token);
                        _this.getData(formData)
                    })
                }

            },
            handlSearch() {
                let params = new FormData();
                params.append('token', this.$global.token);
                params.append('title', this.search);
                params.append('signState', this.value);
                this.getData(params);
            },
            handlDateChange() {

                let params = new FormData();
                params.append('token', this.$global.token);
                params.append('title', this.search);
                params.append('signState', this.value);
                if (this.date == null) {
                    this.timeState = 1;
                    console.log(this.date);
                    this.getData(params);

                } else {
                    params.append('startTime', this.date[0]);
                    params.append('endTime', this.date[1]);
                    this.getData(params);
                }


            },
            handlCheckSend() {
                let _this = this;
                let param = new FormData();
                param.append('id', this.contractId);
                param.append('name', _this.send.name);
                param.append('phone', _this.send.EmaPho);
                param.append('token', _this.$global.token);
                _this.api.sendContact(param).then(res => {
                    console.log(res);
                    if( res.code!=0 ){
                        _this.$message.error( res.msg);
                    }else{

                        _this.$message.success('抄送成功');
                        this.userDialogVisible = false;
                        let formData = new FormData();
                        formData.append('token', _this.$global.token);
                        _this.getData(formData)
                    }
                })
            },
            handlDeleted(row) {
                let _this = this;

                _this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let param = new FormData();
                    param.append('contactId', row.id);
                    // param.append('token', _this.$global.token);
                    _this.api.delContactInfo(param).then(res => {
                        console.log(res)
                        _this.$message.success('删除成功');
                        let formData = new FormData();
                        formData.append('token', _this.$global.token);
                        _this.getData(formData)
                    })
                }).catch(() => {
                });

            },
            handlCheckLook(row) {
                if (row.signState === '起草中') {

                    if(row.type=='2'){
                        this.$router.push({
                            name: 'signContract',
                            params: {
                                yes: 1,
                                pdf: row.contactPath,
                            }
                        })
                    }else{

                        this.$router.push({
                            name: 'detalContract',
                            params: {
                                id: row.id,
                                isMy: 1,
                                isLook: 0,
                                title: row.title,
                                list: 1 //区分从哪里进入
                            }
                        })
                    }

                } else {
                    // } else if (row.signState == '我签署完成' || row.signState == '他人签署完成') {
                    this.$router.push({
                        name: 'signContract',
                        params: {
                            yes: 1,
                            pdf: row.contactPath,
                        }
                    })
                } /*else {
                    this.$router.push({
                        name: 'detalContract',
                        params: {
                            id: row.id,
                            isMy: 1,
                            isLook: 1,
                            isSign: row.signState,
                            pdf: row.contactPath,
                            title: row.title,
                            list: 1 //区分从哪里进入
                        }
                    })
                }*/
            },
            getState(index) {
                if (index == 0) {
                    return '起草中'
                } else if (index == 1) {
                    return '待他人签名'
                } else if (index == 2) {
                    return '需要我签名'
                } else if (index == 3) {
                    return '我签署完成'
                } else if (index == 4) {
                    return '已取消'
                } else if (index == 5) {
                    return '他人签署完成'
                }
            },
            getData(param) {
                let _this = this;
                _this.tableData = [];
                _this.api.getContactList(param).then(res => {
                    console.log(res);
                    // _this.tableData = res.data;
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].signState = _this.getState(res.data[i].signState);
                        if (res.data[i].delFlag == 1) {
                            if (res.data[i].memberId != _this.$global.webData.id) {
                                console.log("第几条")
                                if (res.data[i].signState == "待他人签名") {
                                    res.data[i].signState = "需要我签名"
                                } else if (res.data[i].signState == "他人签署完成") {
                                    res.data[i].signState = "我签署完成"
                                }
                            }
                            _this.tableData.push(res.data[i])
                        }

                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .titleClass {
        border: none;
        font-size: 18px;
    }

    #table .tableHeader {
        width: @a;
        height: @a;
        @row();

        span {
            width: auto;
        }
    }

    #table .tableScope {
        width: @a;
        height: @a;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    #table /deep/ .el-input__inner {
        width: 120px;
        height: 30px;
        margin-left: 15px;
    }

    #table /deep/ .el-input__icon {
        line-height: 30px;
    }

    #table /deep/ td {
        font-size: 18px;
        color: #333333;
        letter-spacing: 1px;
    }

    #table /deep/ td > .cell {
        @row();
        height: 60px;
    }

    #table /deep/ th {
        height: 80px;
        background-color: #f5f5f5;
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        // @row();
        padding: 0 !important;
    }

    #table /deep/ th > .cell {
        text-align: center;
        overflow: initial;
        @row();
        height: 80px;
    }


    #userDialog /deep/ .el-dialog--center .el-dialog__body {
        padding-top: 0;
    }

    #userDialog /deep/ .el-dialog--center {
        border-radius: 30px;
    }

    #userDialog /deep/ .el-dialog__header {
        padding: 0;
        width: @a;
        height: 80px;
    }

    #userDialog /deep/ .el-dialog__title {
        width: @a;
        height: 100px;
        text-align: center;
        font-family: MicrosoftYaHei-Bold;
        font-size: 36px !important;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #333333 !important;
        line-height: 100px;
    }

    #userDialog .dialogUser {
        width: @a;
        height: 60px;
        margin-top: 30px;

        /deep/ .el-input__inner {
            width: @a;
            height: 60px;
        }
    }

    #userDialog .dialogEmPh {
        width: @a;
        height: 60px;

        /deep/ .el-input__inner {
            width: @a;
            height: 60px;

        }
    }

    #userDialog .dialog_btn {
        width: @a;
        height: 80px;
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        letter-spacing: 1px;
        color: #fff;
        line-height: 80px;
        text-align: center;
        margin-top: 30px;
        cursor: pointer;

    }

    #table /deep/ .el-table__body tr:hover > td {
        background-image: linear-gradient(#1e6eee 0%, #109ee7 50%, #01cee0 100%);
        color: #fff;
    }


    .contract {
        width: @a;
        height: auto;

        .mess_right {
            width: 1222px;
            height: auto;
            padding-left: 4%;

            .mess_title {
                width: @a;
                height: 40px;
                display: @flex;
                align-items: center;
                justify-content: space-between;

                .text {
                    width: 125px;
                    height: 40px;
                    line-height: 40px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .search {
                    width: 370px;
                    height: 40px;
                    margin-left: 50px;
                    display: @flex;

                    /deep/ .el-input {
                        width: auto;
                    }

                    .btn {
                        width: 80px;
                        height: 40px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 16px;
                        @row();
                        cursor: pointer;
                    }
                }

                .dateText {
                    width: 150px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                }
            }

            .mess_table {
                width: @a;
                height: auto;
                margin-top: 30px;
                background-color: #f5f5f5;
                box-shadow: 0px 0px 10px 0px rgba(180, 180, 180, 0.41);

                .tableBtn:first-child {
                    margin-left: 0;
                }

                .tableBtn {
                    padding: 2px 6px;
                    margin-left: 10px;
                    background-color: #fff;

                    border-radius: 15px;
                    border: solid 1px #aaaaaa;
                    font-size: 14px;
                    cursor: pointer;
                    color: #333333 !important;
                }

                .tableBtnS {
                    padding: 6px 10px;
                    margin-left: 10px;
                    background-image: linear-gradient(#1e6eee 0%, #109ee7 50%, #01cee0 100%);
                    border-radius: 15px;
                    font-size: 18px;
                    font-weight: 550;
                    cursor: pointer;
                    color: #fff;
                }

                .table_body {
                    width: @a;
                    height: 60px;


                    .table_for {
                        width: @a;
                        height: 60px;
                        display: @flex;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/contract/contractSin.vue